import axios from 'axios';
// import { generateHmacSignature } from '../utils/hmac';
import envConfig from '../envConfig';

// const APP_ID = 'pxIaENR8HoQyumoG2WN0ew==';

// const MASTER_COMM_URL = 'https://digmetadata-qa.aexp.com/myca/dig/resthub/occ/getCommMasterData';
// original: 'https://digmetadata-qa.aexp.com/myca/dig/resthub/occ/getCommMasterData';

// const CARD_LIST_URL = 'http://localhost:8011/proxy/account_servicing/member/v1/accounts';
// original: 'https://memactglobalsvc-qa.aexp.com/account_servicing/member/v1/accounts';

// const ACCOUNTS_API = 'http://localhost:8016/proxy/ecommsvc/eaddser/api/v1/email/accounts';
// 'https://eaddsvc-qaeusw1a4.aexp.com/ecommsvc/eaddser/api/v1/email/accounts';

// const DETOKENIZE_URL = 'http://localhost:8018/proxy/account_servicing/tokenizer/v1/detokenize';
// 'https://tokenizersvc-qa.aexp.com/account_servicing/tokenizer/v1/detokenize';

// const TOKEN_URL = 'http://localhost:8010/proxy/security/digital/v1/application/token';

// // Card service credentials (same JWT endpoint, different appId/secret/scope)
// const CARD_APP_ID = 'ca3a0994-f5aa-3d5b-a54c-f0d5cefaf82f';
// const CARD_SECRET = 've3HMfegPllzzXYSP92iRyZLFsQw0l6I8laSuF2enJk=';
const CARD_CLIENT_ID = '118826220_DCPService'; //! todo remove this hardcoded value and use real data from API

// Mock LOAD API for OCC flow

// export const loadOccData = (add) => new Promise((resolve, reject) => {
//   // simulate API delay
//   setTimeout(() => {
//     if (!add) {
//       reject(new Error('Invalid token'));
//       return;
//     }

//     // 🔹 Mock response (same shape as backend)
//     resolve({
//       status: 'success',
//       result: {
//         emailObj: {
//           maskedEmail: 'n*****@gmail.com',
//           emailAddress: 'namit@gmail.com',
//           encryptedEmail: add,
//         },
//         urlLinks: {},
//       },
//     });
//   }, 800);
// });

// 🔹 SAVE API (NEW)
export const updateOccPreferences = emailAddress => new Promise((resolve, reject) => {
  setTimeout(() => {
    if (!emailAddress) {
      reject(new Error('Missing emailAddress'));
      return;
    }

    // 🔹 simulate success response
    resolve({
      status: 'success',
      description: 'Optedout Successfully'
    });

    // 🔹 (optional) simulate failure for testing
    // reject(new Error('API failure'));
  }, 800);
});
export const getMasterCommData = async env => {
  try {
    var _envConfig$env, _envConfig$env2, _response$data, _response$data2;
    const response = await axios.get((_envConfig$env = envConfig[env]) === null || _envConfig$env === void 0 ? void 0 : _envConfig$env.MASTER_COMM_URL, {
      headers: {
        AppId: (_envConfig$env2 = envConfig[env]) === null || _envConfig$env2 === void 0 ? void 0 : _envConfig$env2.MASTER_COMM_APP_ID
      }
    });

    // console.log('FULL RESPONSE:', response);

    if ((response === null || response === void 0 || (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.bmsg.trim()) !== 'SUCCESS') {
      throw new Error('API failed here');
    }
    const masterCommData = {};
    // comm code mapping with commun_cd as key and rest of data as value
    response === null || response === void 0 || (_response$data2 = response.data) === null || _response$data2 === void 0 || _response$data2.results.forEach(item => {
      const code = item.COMMUN_CD.trim();
      masterCommData[code] = item;
    });

    // console.log('Master Comm Data:', masterCommData);

    return masterCommData;
  } catch (error) {
    console.error('Master Comm API error:', error);
    return null;
  }
};
// mock API for SAVE preferences
// export const updateOccNewsletterMock = async () => new Promise((resolve) => {
//   setTimeout(() => {
//     resolve({
//       status: 'success',
//       description: 'Update operation Successful',
//     });
//   }, 500);
// });
// const USE_MOCK_SAVE_API = true; // toggle to switch between mock and real API for SAVE

// export const updateOccNewsletter = async (payload) => {
//   if (USE_MOCK_SAVE_API) {
//     return updateOccNewsletterMock(payload);
//   }

//   // 🔹 real API (later)
//   return axios.post('/real-api', payload);
// };

export const getCardList = async (accountTokens, cardToken, env) => {
  try {
    var _envConfig$env3;
    // Step 1: Get JWT token (same pattern as getApplicationToken in privacy.service.js)
    // const { signature, timestamp } = await generateHmacSignature(
    //   CARD_APP_ID,
    //   CARD_SECRET
    // );
    // const headers = {
    //   'Content-Type': 'application/json',
    //   'X-Auth-AppID': CARD_APP_ID,
    //   'X-Auth-Signature': signature,
    //   'X-Auth-Version': '2',
    //   'X-Auth-Timestamp': timestamp,
    //   Accept: 'application/json',
    // };

    // const body = {
    //   scope: ['*'],
    // };
    // let tokenRes;
    // try {
    //   const tokenResp = await axios.post(TOKEN_URL, body, {
    //     headers,
    //   });
    //   tokenRes = tokenResp?.data;
    // } catch (err) {
    //   console.error('Error fetching Card JWT token:', err);
    //   return null;
    // }

    // const jwt = tokenRes?.authorization_token;
    if (!cardToken) throw new Error('Card JWT token not received');

    // Step 2: Call member service with account tokens
    const tokens = Array.isArray(accountTokens) ? accountTokens.join(',') : accountTokens;
    // console.log('Calling Card List API with tokens:', tokens);
    const response = await axios.get((_envConfig$env3 = envConfig[env]) === null || _envConfig$env3 === void 0 ? void 0 : _envConfig$env3.CARD_LIST_URL, {
      headers: {
        Authorization: `Bearer ${cardToken}`,
        account_tokens: tokens,
        client_id: CARD_CLIENT_ID,
        correlation_id: `corr_${Date.now()}`,
        'Content-Type': 'application/json',
        Accept: 'application/json'
      }
    });
    // console.log('Card List API Response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Card List API Error:', error);
    return null;
  }
};
export const getAccountsMock = async () => [{
  accountNumber: '123456789012345' //! todo remove this hardcoded value and use real data from API
}];
// 🔹 REAL + MOCK SWITCH
export const getAccounts = async (email, env) => {
  try {
    var _envConfig$env4;
    // if (!USE_MOCK_SAVE_API) {
    //   return await getAccountsMock(email);
    // }

    const response = await axios.get((_envConfig$env4 = envConfig[env]) === null || _envConfig$env4 === void 0 ? void 0 : _envConfig$env4.ACCOUNTS_API, {
      params: {
        purpose_code: 'SERVICING',
        role: 'CARD_HOLDER',
        relationship_type: 'CARD_CUSTOMER'
      },
      headers: {
        email,
        client_id: 'dcpperftest',
        //! todo remove this hardcoded value and use real data from API
        corr_id: '223dddd' //! todo remove this hardcoded value and use real data from API
        // security_token: 'sf', // add later if required
      }
    });
    return response.data;
  } catch (error) {
    console.error('Accounts API Error:', error);
    return null;
  }
};

// export const detokenizeAccounts = async (payload) => {
//   try {
//     const response = await axios.post(DETOKENIZE_URL, payload, {
//       headers: {
//         correlation_id: `corr_${Date.now()}`, // dynamic
//         client_id: 'TheFactory500000859',
//       },
//     });

//     return response.data;
//   } catch (error) {
//     console.error('Detokenize API Error:', error);
//     return null;
//   }
// };